// Experiment here: https://codesandbox.io/s/practical-engelbart-o3bdk

export const createCycler = (elements, opts) => {
    const { colors, interval = 100, numCycles = 1, colorKey = 'fill' } = opts

    const cyclerId = Math.random()
    const elementsCopy = jsonCopy(elements)
    const indexGroups = getIndexGroups(elements, opts)
    const numGroups = indexGroups.length

    let colorsToCycle = []
    let currentCycleIndex = 0

    const cycle = async () => {
        cycler.running = true
        // Colors are cycled as a FIFO queue.
        colorsToCycle = [...colors]
        currentCycleIndex = numCycles - 1

        const defaultColorGroups = indexGroups.map((group, i) => {
            return group.map(elIndex => elements[elIndex][colorKey])
        })
        colorsToCycle.unshift(...defaultColorGroups)

        while (colorsToCycle.length > 0) {
            if (
                colorsToCycle.length === defaultColorGroups.length &&
                currentCycleIndex > 0
            ) {
                currentCycleIndex--
                colorsToCycle.push(...colors)
            }
            for (let i = numGroups - 1; i >= 0; i--) {
                const pathIndexes = indexGroups[i]
                const prevPathIndexes = indexGroups[i - 1]

                // The current index group receives the previous groups colors.
                let currentColor = prevPathIndexes?.currentColor
                // Must be the first iteration cycle
                if (!currentColor) {
                    currentColor = prevPathIndexes?.map(i => elements[i][colorKey])
                }

                if (!currentColor) {
                    currentColor = colorsToCycle.pop()
                }
                // previousColor is either a string, or an array of strings
                if (!currentColor?.length) {
                    break
                }

                // Every element in the same index group receives the same color
                pathIndexes.forEach((elIndex, i) => {
                    const path = elements[elIndex]
                    let color
                    if (Array.isArray(currentColor)) {
                        // Index groups are not guaranteed to have equal lengths
                        // assign what we can, then fallback to the 1st color
                        color = currentColor[i] ?? currentColor[0]
                    } else {
                        color = currentColor
                    }

                    path[colorKey] = color
                })
                pathIndexes.currentColor = currentColor
            }
            await sleep(interval)
        }
        cycler.running = false
    }
    const stop = () => {
        colorsToCycle.splice(0)
        // Restore default colors
        for (let i = 0; i < elements.length; i++) {
            elements[i][colorKey] = elementsCopy[i][colorKey]
        }
        cycler.running = false
    }

    const cycler = { cycle, stop, id: cyclerId, running: false }

    return cycler
}

const getIndexGroups = (elements, opts) => {
    const { flow = 'default' } = opts

    if (flow === 'default') {
        return getDefaultIndexGroups(elements)
    } else if (flow === 'random') {
        return getRandomIndexGroups(elements)
    } else {
        return flow
    }
}

const getDefaultIndexGroups = elements => {
    return elements
        .slice()
        .map((el, i) => ({ i, order: el.order }))
        .sort((a, b) => a.order - b.order)
        .map(d => [d.i])
}

const getRandomIndexGroups = elements => {
    return shuffle(getDefaultIndexGroups(elements))
}

// https://stackoverflow.com/a/2450976/2498782
function shuffle (array) {
    var currentIndex = array.length
    var temporaryValue
    var randomIndex

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
    }

    return array
}

export const COLORS = {}
